import Vuex from 'vuex';
import Vue from 'vue';
import 'whatwg-fetch';
import { integer } from 'vee-validate/dist/rules';

Vue.use(Vuex);

export default new Vuex.Store({

  state: { //are the data
    formData: {
      asn: "",
      companyName: "",
      exchangeOptions: new Array(),
      choosedExchanges: new Array(),
      contactMail: "",
      contactPhone: "",
      prefixIPv4: "",
      prefixIPv6: "",
      message: "",
      disabled: true,
      disableExchanges: true,
      isloading: false,
      noExchanges: false
    },
    networkDetails: {
    }
  },
  // are the computed properties (global property) - filter and calculate on runtime
  getters: {
    getIXByName(state) {
      return name => state.networkDetails.internetExchanges.filter(internetExchanges => { return internetExchanges.name === name });
    },
    getChoosedIXByName(state){
        return name => state.formData.choosedExchanges.filter(choosedExchanges => { return choosedExchanges.name === name });
  }
  },

  actions: { //methods - API call to fetch the products
    async fetchData(context, captchaToken) {
      try {
        const res = await fetch('/api/notification/send/', {
          method: 'POST',
          headers: {'Content-Type': 'application/json'},
          body: JSON.stringify({ ...context.state.formData, captchaToken })
        });
        return res.ok;
      } catch (error) {
        return false;
      }
    }
  },

  mutations: { // setting and updating the state

    async laodNetworkData(state) {
      if (state.formData.asn !== "") {
        state.formData.disabled = true;
        state.formData.exchangeOptions = new Array();
        state.formData.choosedExchanges = new Array();
        state.formData.prefixIPv4= "";
        state.formData.prefixIPv6= "";
        state.formData.contactMail="";
        const res = await fetch('/api/network/details/' + state.formData.asn).then((response)=>{
          if(response.ok){
            return response.json();
          } else {
            throw new Error ('Something went wrong');
          }
        }).then((responseJSON) =>{
          state.networkDetails = responseJSON;
          state.formData.companyName = state.networkDetails.name;
          state.formData.isloading = false;
          state.formData.prefixIPv4 = state.networkDetails.prefix4;
          state.formData.prefixIPv6 = state.networkDetails.prefix6;
          state.formData.contactMail=state.networkDetails.mail;
          state.formData.noExchanges = false;
          state.formData.disableExchanges = false;

          if (state.networkDetails.internetExchanges.length === 0) {
              state.formData.noExchanges = true;
              state.formData.choosedExchanges = "No common";
              state.formData.disabled = false;
            }
        }).catch((error) => {
            state.formData.noExchanges = true;
            state.formData.isloading = false;
            state.formData.choosedExchanges = "No common";
            state.formData.companyName = "No company with this ASN!";
            state.formData.prefixIPv4= "";
            state.formData.prefixIPv6= "";
            state.formData.disabled = true;
            state.formData.disableExchanges = true;
        });
      }
    },

    setFormDataAsn(state, asn) {
      state.formData.asn = asn;
    },

    setFormDataCompanyName(state, company) {
      state.formData.companyName = company;
    },

    setFormDataExchangeOptions(state, option) {
      state.formData.exchangeOptions = option;
      if (state.formData.exchangeOptions.length === 0) {
        state.formData.disabled = true;
      } else {
        state.formData.disabled = false;
      }
    },

    setFormDataChoosedExchangesEntries(state, name) {
      let ip4 = [];
      let ip6 = [];
      for(var i = 0; i < state.networkDetails.internetExchanges.length; i++) {
        if (state.networkDetails.internetExchanges[i].name === name) {
            if(state.networkDetails.internetExchanges[i].ipaddr4.length === 1 && state.networkDetails.internetExchanges[i].ipaddr4[0] === null){
              ip4 = ['none'];
            } else {
              ip4 = state.networkDetails.internetExchanges[i].ipaddr4;
            }
            if(state.networkDetails.internetExchanges[i].ipaddr6.length === 1 && state.networkDetails.internetExchanges[i].ipaddr6[0] === null){
              ip6 = ['none'];
            } else {
              ip6 = state.networkDetails.internetExchanges[i].ipaddr6;
            }
          }
      }
      state.formData.choosedExchanges.push({ name: name, ip4: ip4, ip6: ip6, error: "" });
    },

    setFormDataChoosedExchangesIP4(state, ip4) {
      for (var i = 0; i < state.formData.choosedExchanges.length; i++) {
        if (state.formData.choosedExchanges[i].name === ip4.name) {
          state.formData.choosedExchanges[i].error = "";
          state.formData.choosedExchanges[i].ip4 = ip4.value;
        }
      }
    },

    setFormDataChoosedExchangesIP6(state, ip6) {
      for (var i = 0; i < state.formData.choosedExchanges.length; i++) {
        if (state.formData.choosedExchanges[i].name === ip6.name) {
          state.formData.choosedExchanges[i].ip6 = ip6.value;
        }
      }
    },

    setFormDataContactPhone(state, value) {
      state.formData.contactPhone = value;
    },

    setFormDataContactMail(state, value) {
      state.formData.contactMail = value;
    },

    setFormDataPrefixIPv4(state, value) {
      state.formData.prefixIPv4 = value;
    },

    setFormDataPrefixIPv6(state, value) {
      state.formData.prefixIPv6 = value;
    },

    setFormDataMessage(state, value) {
      state.formData.message = value;
    },
    deleteChoosedExchangesEntries(state, value){
      for (var i = 0; i < state.formData.choosedExchanges.length; i++) {
        if (state.formData.choosedExchanges[i].name === value) {
          state.formData.choosedExchanges.splice(i, 1);
        }
      }
    },

    resetSearch(state){
      state.formData.asn = "";
      state.formData.companyName = "";
      state.formData.contactMail="";

      state.formData.exchangeOptions= new Array();
      state.formData.choosedExchanges= new Array(),

      state.formData.prefixIPv4= "";
      state.formData.prefixIPv6= "";

      state.formData.disabled= true;
      state.formData.isloading= false;
      state.formData.noExchanges= false;
      state.formData.disableExchanges = true;

      state.networkDetails= {};
    },

    resetAll(state){
      state.formData.asn = "";
      state.formData.companyName = "";
      state.formData.contactMail = "";
      state.formData.contactPhone = "";
      state.formData.message = "";

      state.formData.exchangeOptions= new Array();
      state.formData.choosedExchanges= new Array(),

      state.formData.prefixIPv4= "";
      state.formData.prefixIPv6= "";

      state.formData.disabled= true;
      state.formData.isloading= false;
      state.formData.noExchanges= false;
      state.formData.disableExchanges = true;

      state.networkDetails= {};
    }
  }


})
